/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalMCPTaskStatus } from './InternalMCPTaskStatus';
import {
    InternalMCPTaskStatusFromJSON,
    InternalMCPTaskStatusFromJSONTyped,
    InternalMCPTaskStatusToJSON,
    InternalMCPTaskStatusToJSONTyped,
} from './InternalMCPTaskStatus';

/**
 * 
 * @export
 * @interface InternalMCPTaskRecord
 */
export interface InternalMCPTaskRecord {
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    taskId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    ownerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    ownerClientId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    parametersHash: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    parametersSchemaVersion: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalMCPTaskRecord
     */
    parameters: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalMCPTaskRecord
     */
    inputResponses?: { [key: string]: any; } | null;
    /**
     * 
     * @type {InternalMCPTaskStatus}
     * @memberof InternalMCPTaskRecord
     */
    status: InternalMCPTaskStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    statusMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    resultSchemaVersion?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalMCPTaskRecord
     */
    result?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    errorSchemaVersion?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalMCPTaskRecord
     */
    error?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    linkedResourceType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskRecord
     */
    linkedResourceId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InternalMCPTaskRecord
     */
    ttlMs?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InternalMCPTaskRecord
     */
    pollIntervalMs: number;
    /**
     * 
     * @type {number}
     * @memberof InternalMCPTaskRecord
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalMCPTaskRecord
     */
    expiresAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof InternalMCPTaskRecord
     */
    terminalAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof InternalMCPTaskRecord
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalMCPTaskRecord
     */
    updatedAt: Date;
}



/**
 * Check if a given object implements the InternalMCPTaskRecord interface.
 */
export function instanceOfInternalMCPTaskRecord(value: object): value is InternalMCPTaskRecord {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('ownerUserId' in value) || value['ownerUserId'] === undefined) return false;
    if (!('ownerClientId' in value) || value['ownerClientId'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('parametersHash' in value) || value['parametersHash'] === undefined) return false;
    if (!('parametersSchemaVersion' in value) || value['parametersSchemaVersion'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('pollIntervalMs' in value) || value['pollIntervalMs'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function InternalMCPTaskRecordFromJSON(json: any): InternalMCPTaskRecord {
    return InternalMCPTaskRecordFromJSONTyped(json, false);
}

export function InternalMCPTaskRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPTaskRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['task_id'],
        'ownerUserId': json['owner_user_id'],
        'ownerClientId': json['owner_client_id'],
        'kind': json['kind'],
        'parametersHash': json['parameters_hash'],
        'parametersSchemaVersion': json['parameters_schema_version'],
        'parameters': json['parameters'],
        'inputResponses': json['input_responses'] == null ? undefined : json['input_responses'],
        'status': InternalMCPTaskStatusFromJSON(json['status']),
        'statusMessage': json['status_message'] == null ? undefined : json['status_message'],
        'resultSchemaVersion': json['result_schema_version'] == null ? undefined : json['result_schema_version'],
        'result': json['result'] == null ? undefined : json['result'],
        'errorSchemaVersion': json['error_schema_version'] == null ? undefined : json['error_schema_version'],
        'error': json['error'] == null ? undefined : json['error'],
        'linkedResourceType': json['linked_resource_type'] == null ? undefined : json['linked_resource_type'],
        'linkedResourceId': json['linked_resource_id'] == null ? undefined : json['linked_resource_id'],
        'ttlMs': json['ttl_ms'] == null ? undefined : json['ttl_ms'],
        'pollIntervalMs': json['poll_interval_ms'],
        'version': json['version'],
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'terminalAt': json['terminal_at'] == null ? undefined : (new Date(json['terminal_at'])),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function InternalMCPTaskRecordToJSON(json: any): InternalMCPTaskRecord {
    return InternalMCPTaskRecordToJSONTyped(json, false);
}

export function InternalMCPTaskRecordToJSONTyped(value?: InternalMCPTaskRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_id': value['taskId'],
        'owner_user_id': value['ownerUserId'],
        'owner_client_id': value['ownerClientId'],
        'kind': value['kind'],
        'parameters_hash': value['parametersHash'],
        'parameters_schema_version': value['parametersSchemaVersion'],
        'parameters': value['parameters'],
        'input_responses': value['inputResponses'],
        'status': InternalMCPTaskStatusToJSON(value['status']),
        'status_message': value['statusMessage'],
        'result_schema_version': value['resultSchemaVersion'],
        'result': value['result'],
        'error_schema_version': value['errorSchemaVersion'],
        'error': value['error'],
        'linked_resource_type': value['linkedResourceType'],
        'linked_resource_id': value['linkedResourceId'],
        'ttl_ms': value['ttlMs'],
        'poll_interval_ms': value['pollIntervalMs'],
        'version': value['version'],
        'expires_at': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
        'terminal_at': value['terminalAt'] == null ? value['terminalAt'] : value['terminalAt'].toISOString(),
        'created_at': value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'].toISOString(),
    };
}

